import { FormControl, Grid } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import CustomAsyncAutocomplete from "../../../../../core-components/theme/components/CustomAsyncAutoComplete";
import { User } from "../../../types";

interface AttendanceSectionProps {
  options: any
  attendanceManager: any
  rosterManager: any
  operator: any
  errors: {
    attendanceManager?: string
    rosterManager?: string
    operator?: string
  }
  onChange: (field: "attendanceManager" | "rosterManager" | "operator", value: string[]) => void
}

const renderUserField = (
  options: any,
  label: string,
  value: string[],
  error: string | undefined,
  field: "attendanceManager" | "rosterManager" | "operator",
  queryKey: string,
  onChange: (field: "attendanceManager" | "rosterManager" | "operator", value: any[]) => void,
) => {
  const handleSelect = useCallback((selectedValue: User[]) => {
    onChange(field, selectedValue || []);
  }, [field, onChange]);

  const renderOption = useCallback((option: any) => (
    <div>
      <div style={{ fontWeight: 500 }}>{option.name}</div>
      <div style={{ fontSize: "0.875rem", color: "#666" }}>
        {option.role} • {option.email}
      </div>
    </div>
  ), []);

  return (
    <FormControl fullWidth error={!!error}>
      <CustomAsyncAutocomplete
        label={label}
        placeholder={`Select ${label.toLowerCase()}...`}
        value={value}
        defaultOptions={options}
        labelKey="name"
        mainKey="_id"
        multiple
        onSelect={handleSelect}
        error={!!error}
        errorText={error}
        renderCustomOption={renderOption}
      />
    </FormControl>
  );
};

const AttendanceSection = memo(
  ({ attendanceManager, rosterManager, operator, options, errors, onChange }: AttendanceSectionProps) => {
    const { t } = useTranslation();

    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {renderUserField(
            options,
            t('escalation.attendanceManager', 'Attendance Manager'),
            attendanceManager,
            errors.attendanceManager,
            "attendanceManager",
            "attendanceManagers",
            onChange,
          )}
        </Grid>
        <Grid item xs={12}>
          {renderUserField(
            options,
            t('escalation.rosterManager', 'Roster Manager'),
            rosterManager,
            errors.rosterManager,
            "rosterManager",
            "rosterManagers",
            onChange,
          )}
        </Grid>
        <Grid item xs={12}>
          {renderUserField(
            options,
            t('escalation.operator', 'Operator'),
            operator,
            errors.operator,
            "operator",
            "operators",
            onChange,
          )}
        </Grid>
      </Grid>
    )
  },
)

export default AttendanceSection;